var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "account__block" },
    [
      _c("div", { staticClass: "d-flex d-lg-block" }, [
        _c(
          "div",
          {
            staticClass:
              "account__block_image h2 d-flex justify-content-center align-items-center",
          },
          [
            !_vm.isaccountroute
              ? _c(
                  "div",
                  {
                    staticClass: "account__block_add_image",
                    on: { click: _vm.redirectToAccount },
                  },
                  [_c("img", { attrs: { src: _vm.getAvatar, alt: "" } })]
                )
              : [
                  _c("div", { staticClass: "account__block_add_image" }, [
                    _c("input", {
                      attrs: {
                        id: "add_image",
                        type: "file",
                        name: "avatar",
                        accept: ".png, .jpg, .jpeg",
                      },
                      on: { change: _vm.updateFile },
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "add_image" } }, [
                      _vm._v(
                        _vm._s(_vm.get_translation_constant("text_add_photo"))
                      ),
                    ]),
                  ]),
                ],
            _vm._v(" "),
            _c("img", { attrs: { src: _vm.getAvatar, alt: "" } }),
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "account__block_data" }, [
          _c(
            "div",
            {
              staticClass: "account__block_info d-flex justify-content-between",
            },
            [
              _c("div", { staticClass: "account__full_name h_text" }, [
                _vm._v(
                  _vm._s(_vm.account.first_name_latin) +
                    " " +
                    _vm._s(_vm.account.last_name_latin) +
                    "\n                    "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "account__code" }, [
                _vm._v(_vm._s(_vm.account.room_id)),
              ]),
            ]
          ),
          _vm._v(" "),
          !_vm.isaccountroute
            ? _c("div", { staticClass: "account__block_link" }, [
                _c("a", { attrs: { href: _vm.accountlink } }, [
                  _vm._v(
                    _vm._s(
                      _vm.get_translation_constant("text_account_management")
                    )
                  ),
                ]),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "account__block_wallet" }, [
        _c("div", { staticClass: "d-flex justify-content-between" }, [
          _vm._v(
            _vm._s(_vm.get_translation_constant("text_fund_on_account")) +
              "\n                "
          ),
          _c("span", { attrs: { id: "balance" } }, [
            _vm._v(_vm._s(_vm.account.balance)),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "account__block_bonus" }, [
        _c("div", { staticClass: "d-flex justify-content-between" }, [
          _c("div", { staticClass: "d-flex align-items-center" }, [
            _vm._v(
              "\n                    " +
                _vm._s(_vm.get_translation_constant("text_bonus")) +
                "\n                    "
            ),
            _c(
              "span",
              { staticClass: "tooltip__block tooltip__bottom tooltip__modal" },
              [
                _c("span", { staticClass: "tooltip__block_trigger" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "14",
                        height: "14",
                        viewBox: "0 0 14 14",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M7 14c3.82 0 7-3.17 7-7 0-3.82-3.18-7-7-7-3.84 0-7 3.18-7 7 0 3.83 3.17 7 7 7zm0-1.17A5.8 5.8 0 011.17 7 5.83 5.83 0 117 12.83zm-.06-8.27c.5 0 .89-.4.89-.9s-.4-.9-.9-.9-.88.4-.88.9.39.9.89.9zm-1.15 6.21h2.8c.28 0 .5-.2.5-.48a.49.49 0 00-.5-.48h-.85V6.32c0-.37-.2-.62-.53-.62H5.9c-.28 0-.5.22-.5.48 0 .28.22.48.5.48h.74v3.15h-.86c-.27 0-.5.22-.5.48 0 .29.23.48.5.48z",
                          fill: "#515154",
                        },
                      }),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "tooltip__block_overlay" }, [
                  _c("span", { staticClass: "tooltip__block_inner" }, [
                    _c("span", { staticClass: "tooltip__block_close" }),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.get_translation_constant("text_invite_friend")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _c("a", { attrs: { href: "#" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.get_translation_constant(
                              "text_learn_more_about_bonus"
                            )
                          )
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("span", { attrs: { id: "bonus" } }, [
            _vm._v(_vm._s(_vm.account.bonus)),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "account__block_wallet" }, [
        _c("div", { staticClass: "d-flex justify-content-between" }, [
          _vm._v(
            _vm._s(
              _vm.get_translation_constant("text_account_sidebar_tariff_type")
            ) + "\n                "
          ),
          _c("span", { attrs: { id: "balance" } }, [
            _vm._v(_vm._s(_vm.account.tariff ? _vm.account.tariff : "-")),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "account__block__actions" }, [
        _c("div", { staticClass: "d-flex d-lg-block" }, [
          _c(
            "a",
            {
              staticClass: "btn btn__medium btn__block btn__blue",
              attrs: {
                href: "#",
                "data-bs-toggle": "modal",
                "data-bs-target": "#balanceRefill",
              },
            },
            [
              _vm._v(
                _vm._s(_vm.get_translation_constant("text_refill_account")) +
                  "\n                "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn__medium btn__block btn__gray_border",
              attrs: { href: _vm.logoutlink },
            },
            [_vm._v(_vm._s(_vm.get_translation_constant("text_logout")))]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "account__block_trigger" }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade modal__custom",
          attrs: {
            id: "balanceRefill",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "balanceRefillTitle",
            "aria-hidden": "true",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered",
              attrs: { role: "document" },
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "h5",
                    {
                      staticClass: "modal-title",
                      attrs: { id: "balanceRefillTitle" },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.get_translation_constant(
                              "text_replenishment_of_balance"
                            )
                          )
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("button", {
                    staticClass: "close",
                    attrs: {
                      type: "button",
                      "data-bs-dismiss": "modal",
                      "aria-label": "Close",
                      id: "balanceRefillClose",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("form", { attrs: { action: "" } }, [
                    _c("div", { staticClass: "row align-items-end" }, [
                      _c("div", { staticClass: "col-12 col-lg-auto" }, [
                        _c("div", { staticClass: "form__col" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.get_translation_constant(
                                  "text_enter_amount"
                                )
                              ) + " ($)"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.refillAmount,
                                expression: "form.refillAmount",
                              },
                            ],
                            staticClass: "form__control w-160 type_tel",
                            attrs: {
                              id: "summ",
                              name: "summ",
                              placeholder: "0",
                              type: "tel",
                            },
                            domProps: { value: _vm.form.refillAmount },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.form,
                                    "refillAmount",
                                    $event.target.value
                                  )
                                },
                                function ($event) {
                                  _vm.form.refillAmount = Math.min(
                                    Number(_vm.form.refillAmount),
                                    10000
                                  )
                                },
                              ],
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12 col-lg-auto" }, [
                        _c("div", { staticClass: "form__col" }, [
                          _c("input", {
                            staticClass:
                              "btn btn__large btn__blue no_width refill__success",
                            attrs: {
                              type: "button",
                              value:
                                _vm.get_translation_constant("text_refill"),
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.refillBalance.apply(null, arguments)
                              },
                            },
                          }),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("alert-modal", {
        attrs: {
          title: _vm.modalTitle,
          type: _vm.modalType,
          message: _vm.modalMessage,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }